import { render, staticRenderFns } from "./ModuleField.vue?vue&type=template&id=644432ba"
import script from "./ModuleField.vue?vue&type=script&lang=js"
export * from "./ModuleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports